<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 8L14.2239 11.9986L10 16" stroke="#6A7285" stroke-width="1.5" stroke-miterlimit="10"/>
</svg>
